<template>
  <el-container>
    <el-header height="220">
      <el-row>
        <el-select
          v-model="queryParams.examId"
          clearable
          placeholder="请选择测评"
          style="margin-left: 5px"
          @change="paperChange"
        >
          <el-option
            v-for="item in examList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-row>
    </el-header>

    <el-main>
      <el-table
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          label="No"
          type="index"
        />
        <el-table-column
          prop="name"
          label="测评名"
        />
        <el-table-column
          prop="name"
          label="试卷名"
        />
        <el-table-column
          prop="examTime"
          label="测评时间"
        />
        <el-table-column
          prop="totalScore"
          label="测评总分"
        />
        <el-table-column
          prop="evalUser"
          label="测评用户"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="320"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="markPaper(scope.row)"
            >去批改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :small="screenWidth <= 768"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="totalSize"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
      />
    </el-main>
  </el-container>
</template>

<script>
import { getExamMarkList, getMarkPapers } from '@/api/exam'

export default {
  name: 'ExamMarkIndex',
  data() {
    return {
      // 屏幕宽度, 为了控制分页条的大小
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 20,
      totalSize: 0,
      dataList: [],
      // **********************************************************************
      queryParams: {
        examId: '',
        pageNumber: 1,
        pageSize: 10
      },
      examList: []
    }
  },
  created() {
    document.title = '阅卷管理'
    this.getData(this.queryParams)
    this.getPapers()
  },
  methods: {
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber
      this.queryParams.pageNumber = this.currentPage
      this.queryParams.pageSize = this.pageSize
      this.getData(this.queryParams)
      // 回到顶部
      scrollTo(0, 0)
    },
    getData(queryParams) {
      getExamMarkList(queryParams).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data.list
          this.totalSize = resp.data.totalSize
        } else {
          this.$message.warning(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    getPapers() {
      getMarkPapers().then(resp => {
        if (resp.code === 0) {
          this.examList = resp.data
          this.getData(this.queryParams)
        } else {
          this.$message.warning(resp.msg)
        }
      })
    },
    // 试卷变化
    paperChange(val) {
      this.queryParams.examId = val
      this.queryParams.pageNumber = this.currentPage
      this.queryParams.pageSize = this.pageSize
      this.getData(this.queryParams)
    },
    markPaper(row) {
      const examId = row.examId
      const evalUser = row.evalUser
      const routeUrl = this.$router.resolve({
        path: '/exam/paper/mark',
        query: {
          examId: examId,
          userId: evalUser
        }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style>
</style>
